import React from 'react';
import { Redirect } from 'react-router-dom';

import checkForm from '../images/check-form.svg';

import { SectionQuestion } from './style/SectionQuestion';
import '../style/prevBriefing.scss';
import MoldalFooter from '../MoldalFooter';
import ScrollTop from '../../Utils/ScrollTop';
import { useHistoryPush } from '../../../services/hooks/UseHistoryPush';

const onClickNoBtn = (e, briefingId, sourceId) => useHistoryPush('/briefing', { briefingId, pre_sale_id: sourceId });

const onClickYesBtn = (e, briefingId, sourceId) => useHistoryPush('/briefing/clonar/selecionar', { briefingId, pre_sale_id: sourceId });

const Clone = (props) => {
	const { history } = props;
	if (typeof history.location.state === 'undefined' || !history.location.state.briefingId) {
		return <Redirect to="./briefings" />;
	}

	const historyState = history.location.state;
	const sourceId = historyState.pre_sale_id || '';

	return (
		<section className="component-briefing">
			<ScrollTop />
			<div className="container-begin-briefing">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<h2>Bem-vindo ao Briefing - Gearbox Mídia</h2>
						</div>
					</div>

					<div className="box-content">
						<div className="row">
							<div className="col-12">
								<div className="box-title">
									<img src={checkForm} alt="ícone formulário" className="icon-form" />
									<h3>{sourceId}
									</h3>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-12">
								<div className="content-briefing">
									<SectionQuestion>
										<h3 id="title-question">VOCÊ GOSTARIA DE UTILIZAR AS RESPOSTAS DE ALGUM OUTRO BRIEFING?</h3>

										<div className="content-buttons">
											<button type="button" className="btn btn-light" onClick={e => onClickNoBtn(e, historyState.briefingId, sourceId)}>Não</button>
											<button type="button" className="btn btn-secondary" onClick={e => onClickYesBtn(e, historyState.briefingId, sourceId)}>Sim</button>
										</div>
									</SectionQuestion>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-12">
								<MoldalFooter />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Clone;
